import { createFileRoute } from '@tanstack/react-router';
import { DocumentationHub } from '@/components/documentation';

export const Route = createFileRoute('/_dashboard/docs/')({
  component: DocumentationPage,
});

function DocumentationPage() {
  return <DocumentationHub />;
}
